import { Link } from "react-router-dom";
import { Logo } from "../../../../constants";
import styles from "./Navbar.module.css";
import { useCallback, useEffect, useState } from "react";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = useCallback(() => setIsOpen(false), []);
  const toggleMenu = () => setIsOpen((prev) => !prev);

  /* Lock body scroll while drawer is open */
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  /* Close on Escape key */
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape" && isOpen) closeMenu();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [isOpen, closeMenu]);

  /* Auto-close when resizing past the mobile breakpoint */
  useEffect(() => {
    let t;
    const onResize = () => {
      clearTimeout(t);
      t = setTimeout(() => {
        if (window.innerWidth > 968) closeMenu();
      }, 100);
    };
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      clearTimeout(t);
    };
  }, [closeMenu]);

  return (
    <>
      <nav className={styles.nav}>
        <div className={styles.navInner}>
          <Link to="/" className={styles.logoBrand}>
            <Logo color="#030659" />
          </Link>
          <ul className={styles.navLinks}>
            <li>
              <Link to="/features">Features</Link>
            </li>
            <li>
              <Link to="/api-integrations">API &amp; Integrations</Link>
            </li>
            <li>
              <Link to="/pricing">Pricing</Link>
            </li>
            <li>
              <Link to="/talents">For Talent</Link>
            </li>
            <li>
              <Link to="/contact-us" className="">
                Contact Us
              </Link>
            </li>
          </ul>

          <div className={styles.navCta}>
            <Link to="/login" className={`${styles.btn} ${styles.btnGhost}`}>
              Sign in
            </Link>
            <Link
              to="/register"
              className={`${styles.btn} ${styles.btnPrimary}`}
            >
              Get Started
            </Link>

            {/* Hamburger */}
            <button
              type="button"
              className={`${styles.navToggle} ${isOpen ? styles.isOpen : ""}`}
              aria-label={isOpen ? "Close menu" : "Open menu"}
              aria-expanded={isOpen}
              aria-controls="mobile-menu"
              onClick={toggleMenu}
            >
              <span className={styles.bar} />
              <span className={styles.bar} />
              <span className={styles.bar} />
            </button>
          </div>
        </div>
      </nav>

      {/* ── Backdrop ──*/}
      <div
        className={`${styles.backdrop} ${isOpen ? styles.backdropOpen : ""}`}
        aria-hidden="true"
        onClick={closeMenu}
      />

      <aside
        id="mobile-menu"
        className={`${styles.drawer} ${isOpen ? styles.drawerOpen : ""}`}
        aria-label="Mobile menu"
        aria-hidden={!isOpen}
      >
        {/* Header row */}
        <div className={styles.drawerHeader}>
          <Logo />
          <button
            type="button"
            className={styles.drawerClose}
            aria-label="Close menu"
            onClick={closeMenu}
          >
            <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
              <path
                d="M6 6l12 12M6 18L18 6"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                fill="none"
              />
            </svg>
          </button>
        </div>

        {/* Nav links */}
        <nav className={styles.drawerNav} aria-label="Main">
          <Link to="/features" onClick={closeMenu}>
            Features
          </Link>
          <Link to="/api-integrations" onClick={closeMenu}>
            API &amp; Integrations
          </Link>
          <Link to="/pricing" onClick={closeMenu}>
            Pricing
          </Link>
          <Link to="/talents" onClick={closeMenu}>
            For talent
          </Link>
          <Link to="/contact-us" onClick={closeMenu}>
            Contact Us
          </Link>
        </nav>

        {/* CTA buttons */}
        <div className={styles.drawerCta}>
          <Link
            to="/login"
            className={`${styles.btn} ${styles.btnSecondary}`}
            onClick={closeMenu}
          >
            Sign in
          </Link>
          <Link
            to="/register"
            className={`${styles.btn} ${styles.btnPrimary}`}
            onClick={closeMenu}
          >
            Get Started
          </Link>
        </div>
      </aside>
    </>
  );
}
